<template lang="html">
  <div>
      <Form :inline="true" class="form-default form-multi">
        <FormItem :label="$t('INDENT_EWB_NO')" required>
            <Input :placeholder="$t('INDENT_ENTER_VALUE_HERE')" class="form-control" v-model="ewbNumber"></Input>
        </FormItem>
        <FormItem :label="$t('INDENT_EWB_EXPIRY_DATE')" required>
          <DatePicker
            type="datetime"
            format="dd-MM-yyyy hh:mmA"
            v-model="ewbExpiryDate"
            :placeholder="$t('INDENT_PICK_DATE')"
            size="small"
          />
        </FormItem>
      </Form>
       <div class="popover-inner">
          <div class="popover-doc">
            <label>{{$t('EWAY_BILL_COPY')}}<span class="asterisk">*</span></label>
            <Attachments
              :attachments="attachments"
              :showPreview="true"
              @addAttachments="addAttachments($event)"
              @removeAttachments="removeAttachments"
              :maxAllowed=3
            />
          </div>
        </div>
        <div class="popover-footer pt-0 mt-15">
          <Button type="primary" size="mini" @click="submit">
            {{$t('INDENT_SUBMIT')}}
          </Button>
        </div>
  </div>
</template>
<script>
import { FIELD_TYPES } from 'pando-constants';
import Attachments from '@common/components/Attachments';

export default {
  props: ['order', 'getBackDateConfig', 'eximCustomFields'],
  components: {
    Attachments,
  },
  data() {
    return {
      customFieldValues: {},
      FIELD_TYPES,
      ewbNumber: null,
      ewbExpiryDate: new Date(),
      attachments: [],
    };
  },

  created() {
    if (this.order && this.order.eway_bill) {
      this.ewbNumber = this.order.eway_bill.ewb_number;
      this.ewbExpiryDate = this.order.eway_bill.ewb_expiry_date;
      this.attachments = this.order.eway_bill.attachments.map(attachment => ({
        id: attachment._id,
        url: attachment.metadata ? attachment.metadata.location : '',
      })) || [];
    }
  },

  methods: {
    async addAttachments(file) {
      try {
        const formData = new FormData();
        formData.append('attachment', file.raw);
        const result = await this.$store.dispatch(
          'order/addAttachment',
          formData,
        );
        if (result && result.error) {
          this.$error({ message: this.$t('INDENT_UPLOAD_FAILED') });
        } else {
          let attachmentValues = this.attachments || [];
          if (attachmentValues && attachmentValues.length) {
            attachmentValues.push({
              id: result.id,
              url: result.attachment_url,
            });
          } else {
            attachmentValues = [{
              id: result.id,
              url: result.attachment_url,
            }];
          }
          this.attachments = attachmentValues;
        }
      } catch (err) {
        this.$error({ message: this.$t('INDENT_UPLOAD_FAILED') });
      }
    },

    async removeAttachments(file) {
      try {
        const payload = {
          attachment_id: file.id,
        };
        const result = await this.$store.dispatch('order/removeAttachments', payload);
        if (result === 'OK') {
          this.attachments = this.attachments.filter(val => val.id !== file.id);
        } else {
          this.$error({ message: this.$getErr('DELETE_FILE_FAILS') });
        }
      } catch (err) {
        this.$error({ message: this.$getErr('DELETE_FILE_FAILS') });
      }
    },

    async submit() {
      try {
        if (!this.attachments || !this.attachments.length) {
          this.$errorMessage({ message: this.$t('INDENT_EWAY_BILL_ERROR_MSG') });
          return;
        }
        const { order_number: id } = this.order;
        const data = {
          ewb_number: this.ewbNumber,
          ewb_expiry_date: this.ewbExpiryDate,
          attachments: this.attachments.map(attachment => attachment.id),
        };
        const result = await this.$store.dispatch('order/ewayBill', {
          id,
          data,
        });
        if (result.order_number) {
          this.$success({
            message: this.$t('INDENT_EWAY_BILL_SUCCESS_MSG', { order_number: result.order_number }),
          });
        } else {
          this.$error({
            message: this.$t('INDENT_EWAY_BILL_ERROR_MSG'),
          });
        }
      } catch (error) {
        this.$error({
          message: this.$t('INDENT_EWAY_BILL_ERROR_MSG'),
        });
      }
    },
  },
};
</script>
